export const easeOutCubic = (x: number): number => {
  return 1 - Math.pow(1 - x, 3);
};

export const easeOutSine = (x: number): number => {
  return Math.sin((x * Math.PI) / 2);
};
